import requester from '@/lib/axios';
import {
  DNDOrdenationQuestion,
  OrderingQuestionCreateDTO,
} from '@/models/Question';

const baseUrl = 'dnd-ordenation-activity';
const nestedUrl = (activityId: number) => `activities/${activityId}/${baseUrl}`;

export const getOrderingQuestion = async (id: number) => {
  const { data } = await requester().get<DNDOrdenationQuestion>(
    `${baseUrl}/${id}/`,
  );
  return data;
};

export const createOrderingQuestion = async (
  body: Partial<OrderingQuestionCreateDTO>,
) => {
  const { data } = await requester().post<DNDOrdenationQuestion>(
    `${baseUrl}/`,
    body,
  );
  return data;
};

export const updateOrderingQuestion = async (
  id: number,
  changes: Partial<
    Pick<OrderingQuestionCreateDTO, 'title' | 'context' | 'feedbacks'>
  >,
) => {
  const { data } = await requester().patch<DNDOrdenationQuestion>(
    `${baseUrl}/${id}/`,
    changes,
  );
  return data;
};

export const deleteOrderingQuestion = async (id: number) => {
  await requester().delete(`${baseUrl}/${id}/`);
};

export const createOrderingQuestionIntoActivity = async (
  activityId: number,
  body: Partial<OrderingQuestionCreateDTO>,
) => {
  const { data } = await requester().post<DNDOrdenationQuestion>(
    `${nestedUrl(activityId)}/`,
    body,
  );
  return data;
};

export const updateOrderingQuestionIntoActivity = async (
  activityId: number,
  id: number,
  changes: Partial<
    Pick<OrderingQuestionCreateDTO, 'title' | 'context' | 'feedbacks'>
  >,
) => {
  const { data } = await requester().patch<DNDOrdenationQuestion>(
    `${nestedUrl(activityId)}/${id}/`,
    changes,
  );
  return data;
};

export const deleteOrderingQuestionIntoActivity = async (
  activityId: number,
  id: number,
) => {
  await requester().delete(`${nestedUrl(activityId)}/${id}/`);
};
